<template>
    <div :class="{ 'black-overlay': isMenuToggled }">
        <header class="main-header" :class="{ 'main-header--active': isMenuToggled }">
            <div class="mobile-container">
                <div class="main-header__inner">
                    <div v-if="isAuthed" class="main-header__inner__left">
                        <div class="main-header__inner__left__wrap">
                            <mobile-navigation />

                            <router-link
                                :to="{ name: logoLink }"
                                class="main-header__inner__left__wrap__logo-link margin--right"
                            >
                                <img
                                    class="main-header__inner__left__wrap__logo-link__logo"
                                    src="/images/falagrett-logo-white.svg"
                                    alt="Falagrett"
                                />
                            </router-link>

                            <ul
                                v-if="isCertifier || isEmployAdmin || isSuperAdmin || isEmployTeamAdmin"
                                class="main-header__inner__left__wrap__nav"
                                :class="{ 'main-header__inner__left__wrap__nav--active': isMenuToggled }"
                            >
                                <template v-if="currentDepartment?.type === DepartmentType.Educate">
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'certificate' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Alla certifikat"
                                        >
                                            Alla certifikat
                                        </router-link>
                                    </li>
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'create-certificate' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Skapa nya certifikat manuellt eller via fil"
                                        >
                                            Utfärda certifikat
                                        </router-link>
                                    </li>
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'competencies' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Hantera kompetenser"
                                        >
                                            Kompetenser
                                        </router-link>
                                    </li>
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'clients' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Hantera kunder"
                                        >
                                            Kunder
                                        </router-link>
                                    </li>
                                </template>
                                <template v-if="isSuperAdmin">
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'superadmin' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Se alla kunder och användare"
                                        >
                                            Kunder och användare
                                        </router-link>
                                    </li>
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'superadmin-create-certificate' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Skapa nya certifikat manuellt eller via fil"
                                        >
                                            Skapa certifikat
                                        </router-link>
                                    </li>
                                    <li class="main-header__inner__left__wrap__nav__item">
                                        <router-link
                                            :to="{ name: 'superadmin-competences' }"
                                            active-class="active"
                                            class="main-header__inner__left__wrap__nav__item__link"
                                            title="Hantera kompetenser"
                                        >
                                            Kompetenser
                                        </router-link>
                                    </li>
                                </template>
                                <MenuLinks v-if="currentDepartment?.type === DepartmentType.Employ" />
                            </ul>
                        </div>
                    </div>

                    <!-- <router-link
                    v-if="currentDepartment?.type === DepartmentType.Educate"
                    to="/"
                    class="main-header__inner__left__wrap__logo-link"
                >
                    <img
                        class="main-header__inner__left__wrap__logo-link__logo"
                        src="/images/falagrett-logo-white.svg"
                        alt="Falagrett"
                    />
                </router-link> -->

                    <div v-if="isAuthed" class="main-header__inner__right">
                        <button
                            v-if="restoreCache?.token"
                            class="restore-session"
                            title="Växla tillbaka till superadmin"
                            @click="restoreSession"
                        >
                            <VueFeather type="repeat" stroke="#055e9a" /> Växla tillbaka
                        </button>
                        <div class="main-header__inner__right__wrap">
                            <span class="main-header__inner__right__wrap__icon">
                                {{ user?.first_name?.toUpperCase()[0] }}{{ user?.last_name?.toUpperCase()[0] }}
                            </span>
                            <HeaderDrop :is-open="isOpen" @is-open="handleIsOpen" />
                        </div>
                    </div>
                </div>
            </div>
            <Stars v-if="showStars" :limit="10" />
        </header>
    </div>
</template>

<script>
    import { computed } from 'vue';
    import { useStore } from 'vuex';
    import { useRoute } from 'vue-router';
    import { authUser, getCache, removeCache, setCache } from '@/helpers';
    import HeaderDrop from './Dropdown/HeaderDrop';
    import MobileNavigation from './MobileNavigation';
    import Stars from './Stars';
    import VueFeather from 'vue-feather';
    import MenuLinks from './Employ/Navigation/MenuLinks.vue';
    import { DepartmentType } from '@enums/DepartmentType';

    export default {
        components: {
            HeaderDrop,
            MobileNavigation,
            Stars,
            VueFeather,
            MenuLinks,
        },
        setup() {
            const store = useStore();
            const route = useRoute();

            const restoreCache = getCache('restore_session_data');

            const isMenuToggled = computed(() => store.getters['GlobalStore/GET_MOBILE_TOGGLER']);
            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);
            const isOpen = computed(() => store.getters['GlobalStore/getHeaderDropdown']);
            const showStars = computed(() => store.getters['GlobalStore/GET_GLITTER']);
            const user = computed(() => store.getters['UserStore/GET_USER']);
            const pageTitle = computed(() => route.meta.title);
            const currentPath = computed(() => route.name);

            const isSuperAdmin = computed(() => store.getters['UserStore/CAN_USER']('superadmin.*'));
            const isEmployAdmin = computed(() => store.getters['UserStore/CAN_USER']('employ.*'));
            const isEmployTeamAdmin = computed(() => store.getters['UserStore/CAN_USER']('employ.*'));
            const isCertifier = computed(() => store.getters['UserStore/CAN_USER']('certificate.*'));

            const isAuthed = computed(() => authUser());
            const handleIsOpen = () => store.commit('GlobalStore/SET_HEADER_DROPDOWN');

            const logoLink = computed(() => {
                if (currentDepartment.value?.type === DepartmentType.Educate) {
                    return 'certificate';
                } else if (currentDepartment.value?.type === DepartmentType.Employ) {
                    return 'employ-dashboard';
                } else {
                    return 'account';
                }
            });

            const restoreSession = async () => {
                console.log('Restoring original session');

                await store.dispatch('GlobalStore/RESET_STORES');

                setCache(getCache('restore_session_data'));
                removeCache('restore_session_data');

                window.location.href = '/superadmin';
            };

            return {
                restoreCache,
                isAuthed,
                isSuperAdmin,
                isEmployAdmin,
                isCertifier,
                isEmployTeamAdmin,
                user,
                currentDepartment,
                isOpen,
                pageTitle,
                currentPath,
                isMenuToggled,
                handleIsOpen,
                restoreSession,
                showStars,
                DepartmentType,
                logoLink,
            };
        },
    };
</script>
<style scoped>
    .restore-session {
        background: none;
        border: 0;
        margin-right: 16px;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .restore-session:hover {
        text-decoration: underline;
    }

    .margin--right {
        margin-right: 32px;
    }
</style>
